if($(".instagram-wrap").length){
     $('footer#footer').before($('footer#footer .instagram-wrap'))
    $(".instagram-widget>a").each(function(){
    $(".ig-feed").append('<div class="igfeed"><a href="'+$(this).attr("href")+'" target="_blank" style="background-image: url('+$(this).find("img").attr("data-src")+')"></a></div>')})
  }